export const SET_CONFIGS = 'SET_CONFIGS';

export default { SET_CONFIGS };
